var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 5.83333V14.1667C3.33325 16.0076 6.31802 17.5 9.99992 17.5C13.6818 17.5 16.6666 16.0076 16.6666 14.1667V5.83333M3.33325 5.83333C3.33325 7.67428 6.31802 9.16667 9.99992 9.16667C13.6818 9.16667 16.6666 7.67428 16.6666 5.83333M3.33325 5.83333C3.33325 3.99238 6.31802 2.5 9.99992 2.5C13.6818 2.5 16.6666 3.99238 16.6666 5.83333M16.6666 10C16.6666 11.8409 13.6818 13.3333 9.99992 13.3333C6.31802 13.3333 3.33325 11.8409 3.33325 10",
    stroke: "#8F9BBA",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.dc1c9f5bb43a3e1374defda5d82f82d0.svg";
export { ForwardRef as ReactComponent };